import React from 'react';
import { ManageAvatar } from '@europrocurement/l2d-modules';
import { Box, Card } from '@mui/material';
import { Container } from '@mui/system';
import { KeycloakHasRole } from '@europrocurement/l2d-keycloak';
import { CustomAvatar } from '@europrocurement/flexy-components';
import { errorNotification } from '@europrocurement/flexy-components/components/atoms/NotificationToasters';
import { User } from '../../../types/type';

export type UserAvatarProps = {
    user: User;
};

/**
 * Displays avatar gestion component for the selected user.
 * @param user type User
 * @returns ManageAvatar component (if the logged user is admin) or else CustomAvatar component
 */
export const UserAvatar: React.FunctionComponent<UserAvatarProps> = function ({ user }) {
    if (!user.userIdentifier) {
        errorNotification(
            "Impossible de gérer l'avatar car l'utilisateur n'a pas d'identifiant Keycloak",
        );
        return <Box />;
    }

    const userInfos = {
        firstName: user.prenom,
        lastName: user.nom,
        username: user.userIdentifier,
    };

    return (
        <Container sx={{ display: 'flex', justifyContent: 'center' }}>
            <Card sx={{ padding: '25px' }}>
                <KeycloakHasRole
                    kcRole="realm:admin"
                    elseChildren={
                        <CustomAvatar
                            firstName={user.prenom}
                            lastName={user.nom}
                        />
                    }
                >
                    <ManageAvatar user={userInfos} />
                </KeycloakHasRole>
            </Card>
        </Container>
    );
};
